<template>
  <div>not found</div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// NotFound.vue?52b47f2e